import { render, staticRenderFns } from "./IconDeviantart.vue?vue&type=template&id=27fdc415&"
import script from "./IconDeviantart.vue?vue&type=script&lang=js&"
export * from "./IconDeviantart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports